// extracted by mini-css-extract-plugin
export default {"Container":"ApiDomainBadge-module__Container__e0hjn","Staging":"ApiDomainBadge-module__Staging__RbNCy","Development":"ApiDomainBadge-module__Development__ah8Tz"};